import { useEffect, useRef } from 'react';

import { Button, Radar } from '@opositandopn/ui';
import classnames from 'classnames';

import { useCountDownSeconds } from '../../../../hooks/useCountDownTimer';
import { BaseComponentProps } from '../../../../types/base-component.types';

import styles from './Searching.module.scss';

export type ContainerProps = BaseComponentProps & {
  onTimeout: () => void;
  onQuit: () => void;
  seconds: number;
};

function Searching({
  className,
  seconds,
  onTimeout,
  onQuit,
  testId = 'ui-challenge-searching',
}: ContainerProps) {
  const secondsLeft = useCountDownSeconds(seconds);

  // Kept in a ref, so the search gives up when the clock says so and not when
  // the parent happens to hand us a new closure. Reported once: the wait ends
  // the search, and asking twice would end it twice.
  const onTimeoutRef = useRef(onTimeout);
  const reported = useRef(false);

  useEffect(() => {
    onTimeoutRef.current = onTimeout;
  }, [onTimeout]);

  useEffect(() => {
    if (secondsLeft === 0 && !reported.current) {
      reported.current = true;
      onTimeoutRef.current();
    }
  }, [secondsLeft]);

  return (
    <div
      className={classnames(styles['main'], className)}
      data-test-id={testId}
    >
      <span className={styles['title']}>Buscando oponente...</span>
      <Radar />
      <Button
        variant="outline-primary"
        className={styles['button']}
        onClick={onQuit}
      >
        Volver al inicio
      </Button>
    </div>
  );
}

export { Searching };
